import React from 'react';

import './Slide22.css';
import { Slide01_1 } from '../../../assets/Images';

const Slide01_1_popup = () => {
    return (
        <div className="popup">
            <div className="popup-img-wrap">
                <img src={Slide01_1} alt="Percentage of enhancement" />
            </div>
            
        </div>
    );
};

export default Slide01_1_popup;